import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=0c0f310c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f310c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0f310c')) {
      api.createRecord('0c0f310c', component.options)
    } else {
      api.reload('0c0f310c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=0c0f310c&scoped=true&", function () {
      api.rerender('0c0f310c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uLypWyNWd67a/JS/comp/Accordion.vue"
export default component.exports